import { Action } from "@reduxjs/toolkit";
import { BlogState } from "./types";
import { isType } from "typescript-fsa";
import { blogActions } from "./actions";

const initialState: BlogState = {
    total_items: 0,
    total_pages: 0,
    current_page: 1,
    page_size: 10,
    next_page: null,
    previous_page: null,
    blogs: [],
    selectedBlog: null
}

export function BlogReducer(state = initialState, action: Action): BlogState {
    if (isType(action, blogActions.fetchBlogs.done)) {
        const data = action.payload.result
        return {
            ...state,
            total_items: data.total_items,
            total_pages: data.total_pages,
            current_page: data.current_page,
            page_size: data.page_size,
            next_page: data.next_page,
            previous_page: data.previous_page,
            blogs: data.data.map((blog) => ({
                id: blog.id,
                title: blog.title,
                author_name: blog.author_name,
                content: blog.content,
                image: blog.image,
                publish: blog.publish,
                created_at: blog.created_at,
            }))
        }
    }

    if (isType(action, blogActions.getBlogDetails.done)) {
        return {
            ...state,
            selectedBlog: action.payload.result,
        };
    }

    if (isType(action, blogActions.resetToInitialState)) {
        return initialState;
    }

    return state;
}
